import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Team } from '../constants/types';

interface TeamCardProps {
  team: Team;
}

export const TeamCard = ({ team }: TeamCardProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const cardStyle = {
    border: '1.2px solid #8510e6',
    borderRadius: '10px',
    boxShadow: isHovered
      ? '0 6px 12px rgba(0, 0, 0, 1)'
      : '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '5px',
    textAlign: 'center' as const,
    backgroundColor: '#f9f9f9',
    transition: 'all 0.3s ease',
    overflow: 'hidden',
    margin: '10px',
  };

  const imageStyle = {
    maxWidth: '100px',
    display: 'block',
    margin: '10px auto',
    borderRadius: '5px',
  };

  const titleStyle = {
    margin: '10px 0',
    color: '#333',
    fontSize: '1.2rem',
  };

  const rankingStyle = {
    color: '#555',
  };

  const eliminatedStyle = {
    color: '#888',
    margin: '1px',
    fontSize: '13px',
  };

  const handleClick = () => {
    navigate('/squad/' + team.name.toLowerCase().replace(' ', '_'));
  };

  return (
    <>
      <div
        style={cardStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleClick}
      >
        <img style={imageStyle} src={team.flag_url} alt={`${team.name} flag`} />
        <h3 style={titleStyle}>{team.name}</h3>
        <p style={rankingStyle}>Fifa Ranking: {team.fifa_ranking}</p>
        {team.eliminated && <p style={eliminatedStyle}>Eliminated :(</p>}
        {team.name === 'Spain' && <p style={eliminatedStyle}>Winner!</p>}
        {team.name === 'England' && <p style={eliminatedStyle}>Runner-up</p>}
      </div>
    </>
  );
};
